module.exports = __webpack_public_path__ + "img/fwx7.6b08e707.png";